/* Tilted Gaming — shared per-game leaderboard behaviour.
   Split out of templates/page.one-piece-leaderboard.json on 2026-09-04; see the
   header of game-leaderboard.css for why.
   Loaded with defer. The IIFE below guards on document.readyState and calls
   init() itself either way, so it does not care when it runs.
   Everything game-specific comes from data- attributes on #tglb-root — see the
   PER-GAME CONFIG block. Adding a game is a template, not a code change.
   VERIFY BY EXECUTING, NOT BY PARSING. No bundler, no type checking, no CI on
   this file. Extract what you changed and run it against Supabase with the anon
   key, or against a DOM stub. See .claude/LESSONS.md in the app repo.
   The anon key below is public by design and RLS-gated; it is already in the
   page source. A service_role key would be an incident — never put one here. */
(function () {
  var SUPA = 'https://emqkrszhbqydkujminhi.supabase.co';
  var ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtcWtyc3poYnF5ZGt1am1pbmhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwOTg5MzEsImV4cCI6MjA4MzY3NDkzMX0.CzGVa6oLfBlcdfw8UcLJPGWkh-7-AYCz9wDKrUKCBj4';
  var HDR  = { 'apikey': ANON, 'Authorization': 'Bearer ' + ANON, 'Content-Type': 'application/json' };

  /* ── PER-GAME CONFIG ──────────────────────────────────────────────────────
     Every value that used to be hard-coded per page now comes off the root
     element's data- attributes, so all eight game pages can share this file.
     Extracted from page.one-piece-leaderboard.json on 2026-09-04; that page
     and its seven siblings were ~34KB copies of each other, so any change had
     to be made eight times.
     A missing data-game is fatal and says so — silently loading nothing is how
     this class of bug hides. */
  var ROOT = document.getElementById('tglb-root');
  var CFG  = (ROOT && ROOT.dataset) || {};
  if (!CFG.game) {
    console.error('game-leaderboard: #tglb-root is missing data-game — nothing will load');
    return;
  }
  var GAME_KEY   = CFG.game;
  var GAME_LABEL = CFG.label || CFG.game;
  var RANK_SLUG  = CFG.rankKey || CFG.game;
  var BANNER_URL = CFG.banner || '';
  /* The accent is per-game and appears in the JS exactly once — the score-bar
     SVG fill below. It was baked in as One Piece's #f97316 by the first
     extraction, which would have rendered every other game's bars orange. */
  var ACCENT = CFG.accent || '#f97316';
  /* Expose the accent to CSS. Two properties because some rules need an rgba()
     with their own alpha, and CSS cannot take an alpha of a hex custom
     property — hence the r,g,b triple. */
  function accentTriple(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    return m ? (parseInt(m[1], 16) + ',' + parseInt(m[2], 16) + ',' + parseInt(m[3], 16)) : '249,115,22';
  }
  if (ROOT) {
    ROOT.style.setProperty('--tglb-accent', ACCENT);
    ROOT.style.setProperty('--tglb-accent-rgb', accentTriple(ACCENT));
  }

  var allEntries   = [];
  var allSeasons   = [];
  var activeSeason = null;
  var showNick     = false;
  var maxScore     = 1;

  var tbody   = document.getElementById('tglb-tbody');
  var podium  = document.getElementById('tglb-podium');
  var srch    = document.getElementById('tglb-search');
  var nickBtn = document.getElementById('tglb-nick-btn');
  var sBtn    = document.getElementById('tglb-season-btn');
  var sLabel  = document.getElementById('tglb-season-label');
  var sDrop   = document.getElementById('tglb-season-dropdown');
  var colHdr  = document.getElementById('tglb-col-header');
  var bannerImg = document.getElementById('tglb-banner-img');

  /* Banner */
  if (BANNER_URL) {
    bannerImg.src = BANNER_URL;
    bannerImg.removeAttribute('style');
  }

  /* ── Supabase helpers ── */
  function sbGet(path) {
    return fetch(SUPA + path, { headers: HDR }).then(function(r) { return r.json(); });
  }

  function sbRpc(fn, body) {
    return fetch(SUPA + '/rest/v1/rpc/' + fn, {
      method: 'POST', headers: HDR, body: JSON.stringify(body)
    }).then(function(r) { return r.json(); });
  }

  /* ── Rank change (localStorage) ── */
  function getRankKey(sid) { return 'tg_' + RANK_SLUG + '_ranks_' + sid; }

  function loadPrevRanks(sid) {
    try { return JSON.parse(localStorage.getItem(getRankKey(sid)) || 'null') || {}; } catch(e) { return {}; }
  }

  function saveCurRanks(sid, rows) {
    try {
      var map = {};
      rows.forEach(function(r) { map[r.user_id] = r.rank; });
      localStorage.setItem(getRankKey(sid), JSON.stringify(map));
    } catch(e) {}
  }

  /* ── Season dropdown ── */
  function buildDrop() {
    sDrop.innerHTML = '';
    allSeasons.forEach(function(s) {
      var el = document.createElement('div');
      el.className = 'tglb-season-opt' + (activeSeason && s.id === activeSeason.id ? ' active' : '');
      el.innerHTML = esc(s.name) + (s.is_active ? ' <span class="tglb-active-pill">Active</span>' : '');
      el.addEventListener('click', function() {
        activeSeason = s;
        sLabel.textContent = s.name;
        buildDrop();
        closeDrop();
        loadBoard(s.id);
      });
      sDrop.appendChild(el);
    });
  }

  sBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var open = sDrop.classList.toggle('open');
    sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', closeDrop);
  function closeDrop() { sDrop.classList.remove('open'); sBtn.setAttribute('aria-expanded','false'); }

  /* ── Helpers ── */
  function esc(s) {
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function getName(e) {
    return showNick ? (e.display_name||'') : (e.game_account_name||e.display_name||'');
  }

  function winPct(e) {
    var total = e.total_wins + e.total_losses;
    if (!total) return '—';
    return Math.round(e.total_wins / total * 100) + '%';
  }

  function fmtDate(s) {
    if (!s) return '';
    var d = new Date(s + 'T12:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  /* Initials for anyone with no avatar, matching initialsOf() in the app's
     components/Avatar.tsx and tvInitials() on the TV board, so a member looks
     the same in all three places.
     Splits on a LITERAL SPACE. A /\s+/ class does not survive being generated
     through a shell and a JS string — it silently became /s+/ on the TV board,
     which splits on the letter s ('Oscar The Grouch' -> 'OC'). */
  function tglbInitials(name) {
    var parts = String(name || '').trim().split(' ').filter(Boolean);
    if (!parts.length) return '?';
    return (parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '')).toUpperCase();
  }

  function avatarHTML(e, size, cls) {
    size = size || 40;
    var name = esc(getName(e));
    /* APPEND '-ph', do not string-replace. The old code did
         cls.replace('tglb-avatar', 'tglb-avatar-ph')
       which is a no-op for the podium's 'tglb-podium-avatar' — that string does
       not contain 'tglb-avatar' — so the placeholder kept the PHOTO class and
       rendered as an empty bordered circle. The table only worked because its
       class is exactly 'tglb-avatar'. Appending gives the right class for both,
       and both .tglb-avatar-ph and .tglb-podium-avatar-ph already exist. */
    var phCls = cls + '-ph';
    var ini = esc(tglbInitials(getName(e)));
    var phHTML = '<div class="' + phCls + '" aria-hidden="true">' + ini + '</div>';
    if (e && e.avatar_url) {
      /* onerror is not optional: an avatar here can serve 200 with a ZERO-length
         body — every one in this project did before 2026-08-12 — and an empty
         circle reads as 'no picture' rather than 'broken file'. */
      window.tglbAvatarErr = window.tglbAvatarErr || function (i) {
        i.onerror = null; i.style.display = 'none';
        if (i.nextElementSibling) i.nextElementSibling.style.display = '';
      };
      return '<img class="' + cls + '" src="' + esc(e.avatar_url) + '" alt="' + name +
        '" loading="lazy" width="' + size + '" height="' + size + '" onerror="tglbAvatarErr(this)">' +
        phHTML.replace('aria-hidden', 'style="display:none" aria-hidden');
    }
    return phHTML;
  }

  /* ── Stats bar ── */
  function updateStats(rows, season) {
    document.getElementById('tglb-stat-players').textContent = rows.length;
    var totalMatches = rows.reduce(function(acc, r) { return acc + r.total_wins + r.total_losses; }, 0);
    document.getElementById('tglb-stat-matches').textContent = Math.round(totalMatches / 2);
    var maxEv = rows.reduce(function(acc, r) { return Math.max(acc, r.events_played || 0); }, 0);
    document.getElementById('tglb-stat-events').textContent = maxEv || '—';
    if (season && season.start_date && season.end_date) {
      document.getElementById('tglb-stat-dates').textContent = fmtDate(season.start_date) + ' – ' + fmtDate(season.end_date);
    }
  }

  /* ── Podium ── */
  var PODIUM_COLORS = ['#f5c518','#94a3b8','#cd7f32'];
  var PODIUM_LABELS = ['1ST','2ND','3RD'];
  /* The rank FRAME, drawn AROUND the avatar — the same three PNGs the app
     (components/RankFrameAvatar.tsx) and the TV board use, so a podium place
     looks the same in all three places. Keith, 2026-09-04: "remove the badges
     above their head and give them the borders we made". The medallion art it
     replaces is still used for the place badges on profiles.
     Indexed by rank: [gold, silver, bronze]. */
  var RANK_FRAMES = [
    'https://cdn.shopify.com/s/files/1/0916/2598/0198/files/goldborderleader.png?v=1787895817',
    'https://cdn.shopify.com/s/files/1/0916/2598/0198/files/silverborderleader.png?v=1787895817',
    'https://cdn.shopify.com/s/files/1/0916/2598/0198/files/bronzeborderleader.png?v=1787895817',
  ];

  function renderPodium(rows) {
    if (rows.length < 1) { podium.innerHTML = ''; return; }
    var top = [rows[1]||null, rows[0], rows[2]||null]; /* 2nd | 1st | 3rd */
    var cardIdxs = [1, 0, 2]; /* indices into rows[] */
    var baseH = ['tglb-podium-base-2','tglb-podium-base-1','tglb-podium-base-3'];
    var cardCls = ['tglb-podium-2','tglb-podium-1','tglb-podium-3'];

    podium.innerHTML = '';
    top.forEach(function(entry, i) {
      if (!entry) {
        var empty = document.createElement('div');
        empty.className = 'tglb-podium-slot';
        podium.appendChild(empty);
        return;
      }
      var ri = cardIdxs[i];
      var slot = document.createElement('div');
      slot.className = 'tglb-podium-slot';

      var avSz = ri === 0 ? 84 : 72;
      var avCls = 'tglb-podium-avatar';

      slot.innerHTML =
        '<div class="tglb-podium-card ' + cardCls[i] + '">' +
          /* The frame is a square box; the photo inside is a percentage of it,
             because each frame's opening is a different size. Art last so it
             paints over the photo's edge. */
          '<div class="tglb-frame tglb-frame-' + (ri + 1) + '">' +
            avatarHTML(entry, avSz, avCls) +
            '<img class="tglb-frame-art" src="' + RANK_FRAMES[ri] + '" alt="' + PODIUM_LABELS[ri] + ' place">' +
          '</div>' +
          /* No "1ST PLACE" line: the frame says the place and the base plate
             below repeats it as text, so this was the third statement of the
             same fact. Keith, 2026-09-04: "feels like its not needed".
             PODIUM_LABELS is still used by the base plate and the frame's alt
             text, so the place is never colour-only — that would exclude
             anyone who cannot tell gold from bronze. */
          '<span class="tglb-podium-name">' + esc(getName(entry)) + '</span>' +
          '<span class="tglb-podium-score">' + entry.total_score + ' <span style="font-size:1rem;color:rgba(255,255,255,0.3);font-weight:700">PTS</span></span>' +
          '<span class="tglb-podium-wl">' + entry.total_wins + 'W · ' + entry.total_losses + 'L · ' + winPct(entry) + '</span>' +
        '</div>' +
        '<div class="tglb-podium-base ' + baseH[i] + '"><span>' + PODIUM_LABELS[ri] + '</span></div>';

      podium.appendChild(slot);
    });
  }

  /* ── Table (rank 4+) ── */
  function renderTable(rows, prevRanks) {
    var tableRows = rows.filter(function(r) { return r.rank > 3; });

    if (!tableRows.length && rows.length > 0) {
      tbody.innerHTML = '';
      return;
    }
    if (!rows.length) {
      tbody.innerHTML = '<tr class="tglb-empty-row"><td colspan="9">No entries yet this season.</td></tr>';
      return;
    }

    tbody.innerHTML = '';
    tableRows.forEach(function(e) {
      var tr = document.createElement('tr');
      var pct = winPct(e);
      var barWidth = maxScore > 0 ? Math.round((e.total_score / maxScore) * 100) : 0;

      /* rank change */
      var chgHtml = '<span class="tglb-chg-same">–</span>';
      if (prevRanks && prevRanks[e.user_id] !== undefined) {
        var prev = prevRanks[e.user_id];
        var delta = prev - e.rank;
        if (delta > 0)      chgHtml = '<span class="tglb-chg-up">▲' + delta + '</span>';
        else if (delta < 0) chgHtml = '<span class="tglb-chg-down">▼' + Math.abs(delta) + '</span>';
      } else {
        chgHtml = '<span class="tglb-chg-new">NEW</span>';
      }

      tr.innerHTML =
        '<td class="tglb-td-rk"><span class="tglb-rank-num">' + e.rank + '</span></td>' +
        '<td class="tglb-td-chg">' + chgHtml + '</td>' +
        '<td class="tglb-td-player"><div class="tglb-player-cell">' +
          avatarHTML(e, 52, 'tglb-avatar') +
          '<span class="tglb-pname">' + esc(getName(e)) + '</span>' +
        '</div></td>' +
        '<td class="tglb-td-pts">' + e.total_score + '</td>' +
        '<td class="tglb-td-pct">' + pct + '</td>' +
        '<td class="tglb-td-w">'   + e.total_wins    + '</td>' +
        '<td class="tglb-td-l">'   + e.total_losses  + '</td>' +
        '<td class="tglb-td-ew">'  + e.total_event_wins + '</td>';

      tbody.appendChild(tr);

    });
  }

  /* ── Filter + re-render ── */
  var lastPrevRanks = {};

  function filtered() {
    var term = srch.value.toLowerCase().trim();
    if (!term) return allEntries;
    return allEntries.filter(function(e) {
      return (e.game_account_name||'').toLowerCase().indexOf(term) !== -1 ||
             (e.display_name||'').toLowerCase().indexOf(term) !== -1;
    });
  }

  function fullRender() {
    var rows = filtered();
    renderPodium(rows);
    renderTable(rows, lastPrevRanks);
  }

  srch.addEventListener('input', fullRender);

  nickBtn.addEventListener('click', function() {
    showNick = !showNick;
    nickBtn.classList.toggle('active', showNick);
    nickBtn.setAttribute('aria-pressed', showNick ? 'true' : 'false');
    colHdr.textContent = showNick ? 'NICKNAME' : 'PLAYER';
    fullRender();
  });

  /* ── Load board ── */
  function loadBoard(seasonId) {
    podium.innerHTML = '';
    tbody.innerHTML = '<tr class="tglb-loading-row"><td colspan="9">Loading leaderboard\u2026</td></tr>';

    var prevRanks = loadPrevRanks(seasonId);

    Promise.all([
      sbRpc('tg_leaderboard', { p_game_key: GAME_KEY, p_season_id: seasonId }),
      sbGet('/rest/v1/profiles?select=id&show_on_leaderboard=eq.false')
    ])
      .then(function(results) {
        var data    = results[0];
        var optOut  = results[1];

        if (!Array.isArray(data)) throw new Error('bad response');

        var hidden = {};
        if (Array.isArray(optOut)) {
          optOut.forEach(function(p) { hidden[p.id] = true; });
        }

        var rows = data
          .filter(function(r) { return !hidden[r.user_id]; })
          .map(function(r) {
            return {
              rank:              Number(r.rank),
              user_id:           r.user_id,
              display_name:      r.display_name||'',
              game_account_name: r.game_account_name||null,
              avatar_url:        r.avatar_url||null,
              total_score:       Number(r.total_score),
              total_wins:        Number(r.total_wins),
              total_losses:      Number(r.total_losses),
              total_event_wins:  Number(r.total_event_wins||0),
              events_played:     Number(r.events_played||0),
            };
          });

        if (!rows.length) {
          allEntries = [];
          lastPrevRanks = {};
          podium.innerHTML = '';
          tbody.innerHTML = '<tr class="tglb-empty-row"><td colspan="9">No entries yet this season.</td></tr>';
          return;
        }

        allEntries = rows;
        maxScore = rows[0].total_score || 1;
        lastPrevRanks = prevRanks;
        updateStats(rows, activeSeason);
        fullRender();
        setTimeout(function() { saveCurRanks(seasonId, rows); }, 500);
      })
      .catch(function(err) {
        console.error(GAME_LABEL + ' LB:', err);
        tbody.innerHTML = '<tr class="tglb-empty-row"><td colspan="9">Error loading leaderboard.</td></tr>';
      });
  }

  /* ── Init ── */
  function init() {
    sbGet('/rest/v1/seasons?select=*&order=start_date.desc')
      .then(function(seasons) {
        allSeasons = seasons;
        var active = null;
        for (var i = 0; i < seasons.length; i++) { if (seasons[i].is_active) { active = seasons[i]; break; } }
        /* No season is active - a break week. seasons[0] is the NEWEST by
           start_date, which during a break is the one that has not begun yet,
           so this used to show an unstarted season and an empty board: every
           per-game page read "Season 4 - No entries yet this season" through
           the whole break. Found live 2026-09-29.

           Take the most recent season that has actually STARTED instead. The
           list is already ordered start_date.desc, so the first match walking
           down is it, and a finished season's standings are final rather than
           absent - they are the right thing to show until the new one begins.

           Compared against the visitor's own date, not Los Angeles: a season
           boundary is a midnight, so the worst case is someone in a distant
           timezone seeing the previous season for a few hours on changeover
           day, and only during a break. Not worth a round trip to do better. */
        if (!active && seasons.length) {
          var now = new Date();
          var todayIso = now.getFullYear() + '-' +
                         String(now.getMonth() + 1).padStart(2, '0') + '-' +
                         String(now.getDate()).padStart(2, '0');
          for (var j = 0; j < seasons.length; j++) {
            if (seasons[j].start_date <= todayIso) { active = seasons[j]; break; }
          }
          /* Nothing has started at all - a brand new store whose first season
             is still ahead. Show the soonest one rather than nothing, which is
             the oldest entry in a descending list. */
          if (!active) active = seasons[seasons.length - 1];
        }
        activeSeason = active;
        sLabel.textContent = active ? active.name : 'Season';
        buildDrop();
        if (active) loadBoard(active.id);
        else tbody.innerHTML = '<tr class="tglb-empty-row"><td colspan="9">No active season found.</td></tr>';
      })
      .catch(function() {
        tbody.innerHTML = '<tr class="tglb-empty-row"><td colspan="9">Error loading leaderboard.</td></tr>';
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
